import { uiRoutes } from '@consumer-frontend/nc-api';

export const NcPhoneNumberDisclaimer = () => {
  return (
    <p className="disclaimer below-button">
      By providing your phone number, you agree to receive text messages from NetCredit and its lending partners
      regarding your application and loan servicing. Message frequency may vary. Message &amp; data rates may
      apply. Reply STOP to opt out or HELP for help. See our
      {' '}
      <a href={uiRoutes.legacyAH.privacyPolicy}>Privacy Policy</a>
      {', '}
      <a href={uiRoutes.legacyAH.statesPrivacyPolicy}>States Privacy Policy</a>
      {', and '}
      <a href={uiRoutes.legacyAH.termsOfUse}>Terms of Use</a>
      {' for more details.'}
    </p>
  );
};
